module.exports = __webpack_public_path__ + "img/C03TechEliteWarship_ua.8a7fef9b.webp";